import React from 'react'
import FocusSkillImage from 'images/focus_skill/focus_skill.svg'
import styled from 'styled-components'
import { useIsSp } from 'spa/hooks/useIsSp'

const Section = styled.section`
  padding: 1rem calc(1.5rem - 1px);
  border: 1px solid ${props => props.theme.members.colors.silver._50};
  margin-bottom: 2rem;
`

const SectionHeader = styled.header`
  font-size: .875rem;
  font-weight: 700;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;

  @media ${props => props.theme.media.sm} {
    font-size: 1rem;
    margin-bottom: .5rem;
  }
`

const Contents = styled.div`
  @media ${props => props.theme.media.sm} {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
`

const ImageBackground = styled.div`
  background-color: ${props => props.theme.members.colors.silver._10};
  width: 100%;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 1rem;

  @media ${props => props.theme.media.sm} {
    height: 119px;
    width: 200px;
    margin-bottom: 0;
  }
`

const Description = styled.div`
  font-size: .875rem;
  line-height: 1.7;
`

export const StyledFocusSkillDescription: React.FC = () => {
  const isSp = useIsSp()

  return (
    <Section>
      <SectionHeader>注力スキルを設定して{isSp ? <br /> : ''}ぴったりな案件を探そう</SectionHeader>
      <Contents>
        <ImageBackground>
          <img src={FocusSkillImage} alt="スキル横のアイコンから注力スキルを設定" width="84.26" height="20" />
        </ImageBackground>
        <Description>スキル横のアイコンをクリック・タップすることで案件として主力で取り組みたいスキルを5つまで設定することが可能に。設定した「注力スキル」を優先して、あなたによりマッチした案件を探すことができます。</Description>
      </Contents>
    </Section>
  )
}
